// extracted by mini-css-extract-plugin
export default {"wrapper":"CoworkersList_wrapper__V-snq","title":"CoworkersList_title__dZcaY","titles":"CoworkersList_titles__OJYEJ","item":"CoworkersList_item__D4HMs"};